import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Description from "../parts/Description";
import LetterOrderProgress from "../parts/LetterOrderProgress";
import OwnerShipLabel from "../../common/OwnerShip/OwnerShipLabel";
import Icon from "../atoms/Icon";
import Function from "../parts/Function";

const styles = () => ({
  root: {
    width: "calc(100% - 230px)",
    background: "#FFFFFF",
    boxShadow: "0px 0px 3px #00000026",
    borderRadius: "2px",
    marginLeft: "70px",
    padding: "10px 22px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    height: "108px",
  },

  container: {
    width: "calc(100% - 120px)",
    height: "100%",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },

  title: {
    fontSize: "18px",
    color: "#181819",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },

  followCallCount: {
    marginTop: "4px",
    fontSize: "13px",
    color: "#1A65FF",
  },

  owner: {
    marginTop: "4px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
  },
});

class TimelinePanel extends React.Component {
  renderTitle = () => {
    const { classes, firstStatus } = this.props;

    return (
      <div className={classes.title} title={firstStatus.title}>
        {firstStatus.title}
      </div>
    )
  }

  renderFollowCallCount = () => {
    const { classes, followCallCount } = this.props;

    if (followCallCount) {
      return (
        <div className={classes.followCallCount}>{"フォローコール" + followCallCount + "回目"}</div>
      )
    }
  }

  renderOwner = () => {
    const { classes, firstStatus } = this.props;

    if (firstStatus && firstStatus.ownership_user) {
      return (
        <div className={classes.owner}>
          <OwnerShipLabel name={firstStatus.ownership_user.name} />
        </div>
      );
    }
  }

  render() {
    const { classes, status } = this.props;

    return (
      <div className={classes.root}>
        <Icon status={status} />
        <div className={classes.container}>
          {this.renderTitle()}
          {this.renderFollowCallCount()}
          <LetterOrderProgress status={status} />
          <Description status={status} />
          {this.renderOwner()}
        </div>
        <div className="flex"></div>
        <Function
          status={status}
          toggleAddStatusDialog={this.props.toggleAddStatusDialog}
          hasFollowCallOrderAddress={this.props.hasFollowCallOrderAddress}
          toggleEditStatusDialog={this.props.toggleEditStatusDialog}
          toggleLetterOrderDetailDialog={this.props.toggleLetterOrderDetailDialog}
          toggleFollowCallDetailDialog={this.props.toggleFollowCallDetailDialog}
        />
      </div>
    );
  }
}

TimelinePanel.propTypes = {
  classes: PropTypes.object.isRequired,
  firstStatus: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  followCallCount: PropTypes.number,
  toggleEditStatusDialog: PropTypes.func.isRequired,
  hasFollowCallOrderAddress: PropTypes.bool.isRequired,
  toggleAddStatusDialog: PropTypes.func,
  toggleLetterOrderDetailDialog: PropTypes.func.isRequired,
  toggleFollowCallDetailDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(TimelinePanel);



// WEBPACK FOOTER //
// ./src/components/Timeline/panels/TimelinePanel.jsx